import React, { FC, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import {
  Row,
  Col,
  Input,
  Button,
  Select,
  Image,
  Checkbox,
  // TimePicker,
} from "antd";
import { ReactSVG } from "react-svg";
import _ from "lodash";
import { Form } from "antd";
import { useLocation } from "react-router-dom";
import { SocketTopics } from "constants/enums";
import { wrapRequestPayload } from "../../../../helpers/request/RequestPayload";
import {
  getProjectsRequestPublishTopic,
  getProjectsSubscriptionTopic,
  getRespondersSubscriptionTopic,
  getAssetsSubscriptionTopic,
  getPageRequestPublishTopic,
  getPageSubscriptionTopic,
  getCreateTicketPagePublishTopic,
  getCreateTicketPageSubscriptionTopic,
  getAdminRolesTopic,
  getAggregateBdsPublishTopic,
  getAggregateBdsSubscriptionTopic,
} from "hooks/MQTTConstants";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";

import {
  SET_CURRENT_PROJECT,
  SET_SUBMITTED,
  ADD_OTHER_LOCATION,
} from "reducers/reducer";
import { pushNotification } from "utils/notifications";
import moment from "moment";
import { GET_VISIT, GET_STAFF } from "../../../../reducers/reducer";
import { UserTopics } from "constants/enums";
import useSocketActions from "../../../../hooks/socketActions";
import { generateUUID } from "utils/appUtil";
import LocationInput from "../../../../common/LocationInput";
import DateInput from "../../../../common/DateInput";
import TimeInput from "../../../../common/TimeInput";
import { formatObject, formatForRedis } from "utils/appUtil";

const { Option } = Select;

const { TextArea } = Input;

let inputTimeout;

const DispatchPanel: FC<{ socket: ISocket; params: any }> = ({
  socket,
  params,
}) => {
  const [nine11Form] = Form.useForm();
  const [error, setError] = useState<string>("");
  const { screens, setScreens } = params;
  const { search } = useLocation();
  const history = useHistory();
  const { projects, visit, userRequests, staff } = useSelector(
    (state: RootState) => state.auth
  );
  const dispatch = useDispatch();
  const { submitted, page } = useSelector((state: RootState) => state.auth);
  const [searching, setSearching] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  const [pageId, setPageId] = useState<boolean>(false);
  const [callTakerOptions, setCallTakerOptions] = useState([]);
  const [callPeopleOptions, setPeopleOptions] = useState([]);
  const [staffOptions, setStaffOptions] = useState([]);
  const [callType, setCallType] = useState();

  const { getUserRequestPayload } = useSocketActions();
  const adminRoles = useRef(undefined);
  const filterUserRequestId = useRef(generateUUID());
  const submitType = useRef<any>();
  const userRequestRef = useRef<any>([]);
  const adminIdRef = useRef<any>([]);

  const onSubmitHandler = (values: any) => {
    const query = new URLSearchParams(search);
    const userId = query.get("userId");
    const connectionId = query.get("connectionId");
    const pageId = query.get("pageId");
    // fix, check
    if (values["undefined"]) {
      _.merge(values, values["undefined"]);
      delete values["undefined"];
    }
    const unstructuredAttributes = { ...values };
    if (values.visit) {
      values.projectName = visit?.project?.name;
    }
    if (values.date) {
      values.date = moment(values["date"])?.format("MM/DD/YYYY");
    }
    if (values.time) {
      values.time = moment(values["time"])?.format("HH:mm:ss");
    }
    let callTakerName = "";
    const peopleNames = [];
    const peopleIds = [];
    const peoples = [];
    userRequests?.[`${filterUserRequestId.current}`]?.map((user) => {
      if (user.id === values.callTaker)
        callTakerName = callTakerName = `${user.firstName}.${user.lastName}`;
      if (
        values.callType !== "other" &&
        values.people?.indexOf(user.id) !== -1
      ) {
        peopleNames.push(`${user.firstName}.${user.lastName}`);
        peopleIds.push(`${user.id}`);
        peoples.push({
          id: user.id,
          beamId: `${user.firstName}.${user.lastName}`,
          email: user.email,
          phone: user.phone,
        });
      }
    });
    values.callTakerId = values.callTaker;
    values.callTaker = callTakerName;
    if(values?.address){
      values.address.type = "incident-location"
    }
    const extendedAttributes = {};
    Object.keys(values).map((key) => {
      _.merge(extendedAttributes, formatObject(key, key, values[key], [], {}));
    });
    const sortedAttributes: any = {
      ...extendedAttributes,
      peopleIds,
      people: peopleNames?.length > 0 ? peopleNames.join(", ") : undefined,
      shareVendorLink: values.shareVendorLink,
    };
    let title = "";
    if (values.callType === "ticket") {
      title = `Ticket-${values.visitId}-${new Date().toLocaleString()}`;
    } else if (values.callType === "audit") {
      title = `Audit-${values.visitId}-${new Date().toLocaleString()}`;
    } else {
      title = `Generic-${values.subCallType}-${new Date().toLocaleString()}`;
    }
    if(sortedAttributes?.address){
      sortedAttributes.address.type = "location";
    }
    setError(undefined);
    setSearching(true);
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getCreateTicketPagePublishTopic(connectionId),
      wrapRequestPayload({
        userId,
        attributes: sortedAttributes,
        unstructuredAttributes,
        title,
        responders: peoples,
        assets: [],
        connectionId,
        pageId,
        submitted: submitType.current === "close",
      })
    );
  };

  useEffect(() => {
    if (submitted) {
      if (searching) {
        setSearching(false);
        setPageId(undefined);
        pushNotification(
          "Ticket page submitted successfully",
          "success",
          "TOP_CENTER",
          1000
        );
        localStorage.removeItem("form");
        localStorage.removeItem("active");
        setTimeout(() => {
          nine11Form.resetFields();
          if (adminIdRef.current) {
            nine11Form.setFieldsValue({
              people: adminIdRef.current,
            });
          }
        }, 500);
        setScreens({
          ...screens,
          map: false,
        });
        const query = new URLSearchParams(search);
        query.delete("pageId");
        history.replace({
          search: query.toString(),
        });
        dispatch({ type: SET_SUBMITTED, payload: false });
      } else if (saving) {
        setSaving(false);
        setPageId(submitted.pageId);
        pushNotification(
          "Ticket page saved successfully",
          "success",
          "TOP_CENTER",
          1000
        );
        const query = new URLSearchParams(search);
        query.delete("pageId");
        query.append("pageId", submitted.pageId);
        history.replace({
          search: query.toString(),
        });
      }
    }
  }, [
    dispatch,
    history,
    nine11Form,
    saving,
    screens,
    search,
    searching,
    setScreens,
    submitted,
  ]);

  const getAdminRoles = (adminUserId, cudbServiceId) => {
    const query = new URLSearchParams(search);
    const connectionId = query.get("connectionId");
    socket.publishToServiceIdSurvey(
      SocketTopics.SurveyTopics,
      UserTopics.SearchInUser,
      getUserRequestPayload(adminUserId, "$", "$..role"),
      getAdminRolesTopic(connectionId),
      cudbServiceId
    );
    socket.subscribeToSurvey(
      SocketTopics.SurveyTopics,
      getAdminRolesTopic(connectionId),
      (response) => {
        adminRoles.current = response.data?.[0]?.[0];
        getAdminUsers();
      }
    );
  };

  const getAdminUsers = () => {
    const query = new URLSearchParams(search);
    const connectionId = query.get("connectionId");
    const userRequest: any = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
          searchQuery: `@serviceId:{'${formatForRedis(
            projects?.userServiceId
          )}'}`,
          searchOptions: "TIMEOUT 5000",
        },
        load: {
          id: "$.objectId",
          status: "$.nonpersistent.static.live.status",
          live: "$.persistent.static.live",
          admin: "$.persistent.static.admin",
          firstName: "$..profile.firstName",
        },
      },
      apply: {
        expression: "",
        name: "",
      },
      result: {},
      filter: {
        expression: `exists(@firstName)`,
      },
      anyStatus: false,
    };
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getAggregateBdsPublishTopic(connectionId),
      wrapRequestPayload(userRequest, filterUserRequestId.current)
    );
  };

  useEffect(() => {
    if (projects?.adminUserId) {
      const query = new URLSearchParams(search);
      const connectionId = query.get("connectionId");
      getAdminRoles(projects?.adminUserId, projects?.userServiceId);
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getAggregateBdsSubscriptionTopic(connectionId)
      );
    }
  }, [projects]);

  useEffect(() => {
    if (socket.client) {
      const query = new URLSearchParams(search);
      const userId = query.get("userId");
      const connectionId = query.get("connectionId");
      const pageId = query.get("pageId");
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getProjectsSubscriptionTopic(connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getRespondersSubscriptionTopic(connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getAssetsSubscriptionTopic(connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getCreateTicketPageSubscriptionTopic(connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getPageSubscriptionTopic(connectionId)
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getProjectsRequestPublishTopic(connectionId),
        wrapRequestPayload({
          userId,
        })
      );
      if (pageId) {
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          getPageRequestPublishTopic(connectionId),
          wrapRequestPayload(
            {
              objectId: pageId,
              paths: ["$"],
              returnPaths: ["$"],
            },
            pageId
          )
        );
      }
    }
    document.title = "Ticket - Beam";
  }, [search, socket.client]);

  useEffect(() => {
    const query = new URLSearchParams(search);
    const pageId = query.get("pageId");

    if (page && pageId) {
      nine11Form.setFieldsValue({
        ...(page?.persistent?.static?.profile?.unstructuredAttributes ?? {}),
      });
      setCallType(
        page?.persistent?.static?.profile?.unstructuredAttributes?.callType
      );
    }
  }, [page]);

  const getRolesByType = (roles, type) => {
    let userRoles;
    switch (type) {
      case "admin":
        userRoles = roles
          .filter((x: any) => x.permissions.indexOf("admin") !== -1)
          .map((x) => {
            return x._id;
          });
        break;
      case "callTaker":
        userRoles = roles
          .filter((x: any) => x.permissions.indexOf("call-center") !== -1)
          .map((x) => {
            return x._id;
          });
        break;
    }
    return userRoles;
  };

  useEffect(() => {
    if (userRequests && socket.client) {
      if (
        userRequests?.[`${filterUserRequestId.current}`] &&
        JSON.stringify(userRequestRef.current) !==
          JSON.stringify(userRequests?.[`${filterUserRequestId.current}`])
      ) {
        userRequestRef.current =
          userRequests?.[`${filterUserRequestId.current}`];
        const callTakerRole = getRolesByType(adminRoles.current, "callTaker");
        const adminRole = getRolesByType(adminRoles.current, "admin");
        let selectedAdminIds = [];
        let options = [];
        let options1 = [];
        userRequests?.[`${filterUserRequestId.current}`]?.map((user) => {
          if (callTakerRole.indexOf(user?.admin?.profile?.roleId) !== -1) {
            options.push({
              label: `${user.fullName}`,
              value: user.id,
            });
          }
          if (adminRole.indexOf(user?.admin?.profile?.roleId) !== -1) {
            selectedAdminIds.push(user.id);
          }
          options1.push({
            label: `${user.fullName}`,
            value: user.id,
          });
        });
        setCallTakerOptions(options);
        setPeopleOptions(options1);
        adminIdRef.current = selectedAdminIds;
        nine11Form.setFieldsValue({
          people: selectedAdminIds,
        });
      }
    }
  }, [userRequests, socket.client]);

  useEffect(() => {
    if (visit) {
      const incidentLocation = visit?.location
        ? {
            type: 'incident-location',
            label: visit?.location?.address,
            value: {
              description: visit?.location?.address,
              place_id: visit?.location?.locationId,
              coordinates: {
                lat: visit?.location?.latitude,
                long: visit?.location?.longitude,
              },
            },
          }
        : undefined;
      nine11Form.setFieldsValue({
        date: moment(new Date(), "MM/DD/YYYY HH:mm:ss"),
        time: moment(new Date(), "HH:mm:ss"),
        projectId: visit?.project?.projectId,
        vendorId: visit?.staff?.staffId,
        vendorName: visit?.staff?.firstName,
        vendorPhone: visit?.staff?.mobilePhoneNumber
          ? `+1${visit?.staff?.mobilePhoneNumber?.replace(/[^a-zA-Z0-9]/g, "")}`
          : undefined,
        vendorEmail: visit?.staff?.emailAddress?.toLowerCase(),
        storeId: visit?.location?.locationId,
        storeName: visit?.location?.title,
        address: incidentLocation,
      });
      if (incidentLocation) {
        addOtherLocation({ incidentLocation });
        setScreens({
          ...screens,
          map: true,
        });
      }
    }
  }, [visit]);

  useEffect(() => {
    if (staff) {
      let options = [];
      try {
        staff?.map((staff) => {
          options.push({
            label: `${staff.firstName} ${staff.lastName}`,
            value: staff._id,
          });
        });
      } catch (e) {}
      setStaffOptions(options);
    }
  }, [staff]);

  const addOtherLocation = (location) => {
    dispatch({ type: ADD_OTHER_LOCATION, payload: location });
  };

  return (
    <div className="main-column ride-dispatch-panel mr-4">
      <div className="main-content">
        <Form
          className="auth-form"
          name="register-form"
          // initialValues={}
          id="register-form"
          layout="vertical"
          form={nine11Form}
          onFinish={onSubmitHandler}
          requiredMark={false}
          onValuesChange={(value, allValues) => {
            localStorage.setItem("form", JSON.stringify(allValues));
          }}
        >
          <div className="main-header">
            <div className="d-flex">
              <Image src="/images/incident-icon.png" preview={false} />
              <h3 className="ml-3">InStore Help Desk</h3>
            </div>
            <div className="d-flex">
              <ReactSVG
                src="/images/close-icon.svg"
                className="close-icon"
                onClick={() => {
                  setTimeout(() => {
                    localStorage.removeItem("form");
                    dispatch({ type: SET_SUBMITTED, payload: false });
                    nine11Form.resetFields();
                    if (adminIdRef.current) {
                      nine11Form.setFieldsValue({
                        people: adminIdRef.current,
                      });
                    }
                    setScreens({
                      ...screens,
                      map: false,
                    });
                  });
                }}
              />
            </div>
          </div>
          <Row className="mt-3">
            <Col span={24}>
              <Form.Item
                name="callType"
                rules={[{ required: true, message: "**Required Field" }]}
              >
                <Select
                  className="w-full"
                  placeholder="Call type"
                  onChange={(value) => {
                    setCallType(value);
                  }}
                >
                  <Option value="ticket">Ticket</Option>
                  <Option value="audit">Audit</Option>
                  <Option value="other">Other</Option>
                </Select>
              </Form.Item>
            </Col>

            {callType === "other" && (
              <Col span={24} className="mt-3">
                <Form.Item
                  name="subCallType"
                  rules={[{ required: true, message: "**Required Field" }]}
                >
                  <Select className="w-full" placeholder="Sub type">
                    <Option value="accounting">Accounting</Option>
                    <Option value="billing">Billing</Option>
                    <Option value="spam">Spam</Option>
                    <Option value="other">Other</Option>
                  </Select>
                </Form.Item>
              </Col>
            )}
          </Row>
          <div className="main-cards">
            <Row>
              <Col span={12} className="pr-2">
                <Form.Item
                  name="callTaker"
                  rules={[{ required: true, message: "**Required Field" }]}
                >
                  <Select
                    showSearch
                    className="w-full"
                    placeholder="Call Taker"
                    onChange={(value) => {}}
                    filterOption={(input, option) =>
                      (option!.children as unknown as string)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {callTakerOptions?.map((option, index) => (
                      <Option key={index} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12} className="pl-2">
                <Form.Item
                  name="phoneNumber"
                  rules={[{ required: true, message: "**Required Field" }]}
                >
                  <Input placeholder="Phone Number (include +1)" />
                </Form.Item>
              </Col>
            </Row>

            {callType === "other" ? (
              <Row className="mt-3">
                <Col span={24}>
                  <Form.Item name="comments">
                    <TextArea
                      autoSize={{ minRows: 4, maxRows: 6 }}
                      placeholder="Comments"
                    />
                  </Form.Item>
                </Col>
              </Row>
            ) : (
              <React.Fragment>
                <Row className="mt-3">
                  <Col span={24}>
                    <Form.Item name="people">
                      <Select
                        showSearch
                        allowClear
                        mode="multiple"
                        className="w-full"
                        placeholder="People"
                        onChange={(value) => {}}
                        filterOption={(input, option) =>
                          (option!.children as unknown as string)
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {callPeopleOptions?.map((option, index) => (
                          <Option key={index} value={option.value}>
                            {option.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col span={24}>
                    <Form.Item
                      name="visitId"
                      rules={[{ required: true, message: "**Required Field" }]}
                    >
                      <Input
                        placeholder="Visit ID"
                        onChange={(e) => {
                          const visitId = e.target.value;
                          if (inputTimeout) {
                            clearTimeout(inputTimeout);
                          }
                          inputTimeout = setTimeout(() => {
                            dispatch(GET_VISIT({ visitId }));
                          }, 500);
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <hr />

                <Row className="mt-3">
                  <Col span={12}>
                    <div className="datetime-item">
                      <img src="/images/date.png" alt="" />
                      <Form.Item
                        name="date"
                        rules={[
                          { required: false, message: "**Required Field" },
                        ]}
                      >
                        <DateInput placeholder="Date" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={12} className="pl-2">
                    <div className="datetime-item">
                      <img src="/images/time.png" alt="" />
                      <Form.Item
                        rules={[
                          { required: false, message: "**Required Field" },
                        ]}
                        name="time"
                      >
                        <TimeInput name="Time" onChange={(time) => {}} />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col span={24}>
                    <Form.Item name="projectId">
                      <Input placeholder="Project ID" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col span={6} className="pr-2">
                    <Form.Item name="vendorId">
                      <Input placeholder="Vendor ID" />
                    </Form.Item>
                  </Col>
                  <Col span={6} className="pr-2">
                    <Form.Item name="vendorName">
                      <Select
                        showSearch
                        className="w-full"
                        placeholder="Name"
                        onChange={(value) => {
                          const vendor = staff?.find((x) => {
                            return x._id === value;
                          });
                          if (vendor) {
                            nine11Form.setFieldsValue({
                              vendorPhone: vendor?.mobilePhoneNumber
                                ? `+1${vendor?.mobilePhoneNumber?.replace(
                                    /[^a-zA-Z0-9]/g,
                                    ""
                                  )}`
                                : undefined,
                              vendorEmail: vendor?.emailAddress?.toLowerCase(),
                            });
                          }
                        }}
                        filterOption={(input, option) =>
                          (option!.children as unknown as string)
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        onSearch={(staff) => {
                          if (inputTimeout) {
                            clearTimeout(inputTimeout);
                          }
                          inputTimeout = setTimeout(() => {
                            console.log("search staff here", staff);
                            dispatch(GET_STAFF({ staff }));
                          }, 500);
                        }}
                      >
                        {staffOptions.map((option, index) => (
                          <Option key={index} value={option.value}>
                            {option?.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6} className="pr-2">
                    <Form.Item name="vendorPhone">
                      <Input placeholder="Vendor phone (include +1)" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name="vendorEmail">
                      <Input placeholder="Vendor email" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col span={6} className="pr-2">
                    <Form.Item name="storeId">
                      <Input placeholder="Store ID" />
                    </Form.Item>
                  </Col>
                  <Col span={6} className="pr-2">
                    <Form.Item name="storeName">
                      <Input placeholder="Name" />
                    </Form.Item>
                  </Col>
                  <Col span={6} className="pr-2">
                    <Form.Item name="storeContact">
                      <Input placeholder="Contact" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name="storePhone">
                      <Input placeholder="Phone (include +1)" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col span={24}>
                    <Form.Item name="address">
                      <LocationInput
                        placeholder="Address"
                        onChange={(location) => {
                          addOtherLocation({ incidentLocation: location });
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                {callType === "ticket" && (
                  <React.Fragment>
                    <Row className="mt-3">
                      <Col span={24}>
                        <Form.Item name="issue">
                          <Select
                            showSearch
                            className="w-full"
                            placeholder="Issue"
                            onChange={(value) => {}}
                            filterOption={(input, option) =>
                              (option!.children as unknown as string)
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            <Option value={"Planogram"}>Planogram</Option>
                            <Option value={"Kit Not Found"}>
                              Kit Not Found
                            </Option>
                            <Option value={"Manager Refused"}>
                              Manager Refused
                            </Option>
                            <Option value={"Store Closed"}>Store Closed</Option>
                            <Option value={"Wrong Display"}>
                              Wrong Display
                            </Option>
                            <Option value={"Extra time needed"}>
                              Extra time needed
                            </Option>
                            <Option value={"Follow-up needed"}>
                              Follow-up needed
                            </Option>
                            <Option value={"Spam"}>Spam</Option>
                            <Option value={"Verified"}>Verified</Option>
                            <Option value={"Other"}>Other</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col span={24}>
                        <Form.Item name="issueDescription">
                          <TextArea
                            autoSize={{ minRows: 4, maxRows: 6 }}
                            placeholder="Issue Description"
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col span={24}>
                        <Form.Item name="issueAction">
                          <TextArea
                            autoSize={{ minRows: 4, maxRows: 6 }}
                            placeholder="Action"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </React.Fragment>
                )}

                <Row className="mt-3">
                  <Col span={24}>
                    <Form.Item name="shareVendorLink" valuePropName="checked">
                      <Checkbox>
                        Do you want to share link with vendor?
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </div>

          {error && (
            <Form.Item>
              <p className="error">{error}</p>
            </Form.Item>
          )}
          <Row className="action-grp mt-3">
            <Col span={8} className="pr-2">
              <Form.Item>
                <Button
                  className="beam-btn green-btn cover w-full"
                  htmlType="submit"
                  loading={searching}
                  onClick={() => {
                    submitType.current = "submit";
                  }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>

            <Col span={8} className="px-2" onClick={() => {}}>
              <Button
                className="beam-btn yellow-btn cover w-full"
                onClick={() => {
                  setTimeout(() => {
                    localStorage.removeItem("form");
                    dispatch({ type: SET_SUBMITTED, payload: false });
                    nine11Form.resetFields();
                    if (adminIdRef.current) {
                      nine11Form.setFieldsValue({
                        people: adminIdRef.current,
                      });
                    }
                    setScreens({
                      ...screens,
                      map: false,
                    });
                    const query = new URLSearchParams(search);
                    query.delete("pageId");
                    history.replace({
                      search: query.toString(),
                    });
                  });
                }}
              >
                Cancel
              </Button>
            </Col>

            <Col span={8} className="pl-2">
              <Button
                className="beam-btn orange-btn bordered w-full"
                htmlType="submit"
                loading={searching}
                onClick={() => {
                  submitType.current = "close";
                }}
              >
                Save & Close
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};
export default DispatchPanel;
